/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import Slider from 'react-slick'
import cn from 'classnames'
import s from '@pagestyles/Blog.module.scss'
import { useTranslation } from 'react-i18next'
import Link from 'next/link'
import { SlickprevCircle, SlicknextCircle } from '@components/icons'
import Image from '@corratech/pylot-image'
import slickStyles from '@commonStyles/Slick.module.scss'
import { BlogPostsResult } from '@pylot-data/api/operations/get-blog'
import { SinglePostData } from '@pylot-data/api/operations/get-singlepost'
import {
    authorName,
    authorTime,
    authorTitleUrl,
    generateBlogIdentifier
} from '@components/common/CMSBlockConst/cms-block-util'
import { RichContent } from '@corratech/pylot-rich-content'
import { useIsMobile } from '@components/common/IsMobile/useIsMobile'
import PerfectScrollbar from 'react-perfect-scrollbar'

interface BlogSliderParts {
    sliderdetails?: BlogPostsResult
}
export const BlogSlider: React.FC<BlogSliderParts> = ({ sliderdetails }) => {
    const { t } = useTranslation(['blog'])
    const posturlbannerlink = '/blog/'
    const isMobile = useIsMobile()
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: (
            <button type="button" className="slick-prev">
                <SlickprevCircle />
            </button>
        ),
        nextArrow: (
            <button type="button" className="slick-next">
                <SlicknextCircle />
            </button>
        ),
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    dots: true,
                    arrows: false,
                    slidesToScroll: 1.01,
                    slidesToShow: 1.01,
                    centerMode: true,
                    infinite: true,
                    centerPadding: '0px'
                }
            }
        ]
    }

    const blogPostSliderDetails = () => {
        return sliderdetails?.items.map((post: SinglePostData) => {
            return (
                <div className={s['fullBanner']} key={post.post_id}>
                    <div className={s['bannerImages']}>
                        <Link href={`${posturlbannerlink}${post?.identifier}`}>
                            <Image
                                src={post.featured_image}
                                width={920}
                                height={625}
                                alt={post?.title}
                            />
                        </Link>
                    </div>
                    <div className={s['bannerDescription']}>
                        <div className={s['bannerContainer']}>
                            <h3>
                                <Link
                                    href={`${posturlbannerlink}${post?.identifier}`}
                                >
                                    <a className={s['linkUrl']}>
                                        {post?.title}
                                    </a>
                                </Link>
                            </h3>
                            <h6>
                                {post.author && (
                                    <>
                                        {t(`blog||By`)}{' '}
                                        <Link
                                            href={`${posturlbannerlink}author/${generateBlogIdentifier(
                                                post?.author?.name
                                            )}/${post?.author?.author_id}`}
                                        >
                                            {authorName(post)}
                                        </Link>
                                    </>
                                )}
                                {authorTime(post)}
                                <RichContent html={authorTitleUrl(post)} />
                            </h6>
                            <div className={s['clampWrapper']}>
                                <div className={s['clamp']}>
                                    <RichContent
                                        html={post.short_filtered_content}
                                    />
                                </div>
                            </div>
                            <Link
                                href={`${posturlbannerlink}${post?.identifier}`}
                            >
                                <a>{t('blog||Read More...')}</a>
                            </Link>
                        </div>
                    </div>
                </div>
            )
        })
    }

    return (
        <div className={s['mainSlider']}>
            {isMobile ? (
                <div className={cn(s['blogSlider'], slickStyles.root)}>
                    <PerfectScrollbar>
                        <div className={s['mobile-scrollbar-view']}>
                            {blogPostSliderDetails()}
                        </div>
                    </PerfectScrollbar>
                </div>
            ) : (
                <div className={cn(s['blogSlider'], slickStyles.root)}>
                    <Slider {...settings}>{blogPostSliderDetails()}</Slider>
                </div>
            )}
        </div>
    )
}
